<template>
  <div class="text-center">
    <v-bottom-sheet v-model="showDialog">
      <v-list>
        <v-subheader>Sorter etter</v-subheader>
        <v-list>
          <v-list-item-group class="ios" color="primary">
            <v-list-item
              v-for="(item, i) in data"
              :key="i"
              @click="itemSelected(item)"
              :input-value="item.selected"
              :class="{ itemIsActive: item.selected }"
            >
              <v-list-item-content>
                <v-list-item-title>
                  {{ item.name }}
                </v-list-item-title>
              </v-list-item-content>

              <v-list-item-icon>
                <v-icon :color="item.sortDesc ? 'primary' : 'grey'">
                  mdi-arrow-down
                </v-icon>
                <v-icon :color="item.sortDesc === false ? 'primary' : 'grey'">
                  mdi-arrow-up
                </v-icon>
              </v-list-item-icon>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-list>
    </v-bottom-sheet>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
export default Vue.extend({
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    data: {},
  },
  methods: {
    itemSelected(item) {
      this.$emit("click", item);
    },
  },

  computed: {
    showDialog: {
      get(): boolean {
        return this.value;
      },
      set(value: boolean) {
        this.$emit("input", value);
      },
    },
  },
});
</script>

<style lang="scss" scoped>
.ios {
  padding-bottom: calc(0px + env(safe-area-inset-bottom)) !important;
}
.itemIsActive {
  color: inherit !important;
  &:before {
    opacity: 0.12 !important;
  }
}
</style>
